import { UPDATE_ORDER_REDUCER } from "store/actionTypes";
import { ActionType, OrderManagementReducerModal } from "utils/modals";

export const OrderManagementReducer = (
  state: OrderManagementReducerModal = new OrderManagementReducerModal(),
  action: ActionType
) => {
  switch (action.type) {
    case UPDATE_ORDER_REDUCER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
